export default __webpack_public_path__ + "cab601ca9bacc75c0dbe5ac49452d37e.png";